import { CodegenInputType } from '@square/ignition/dist/types/codegen';
import { ApiExplorerMapFieldValue } from '@squareup/dex-types-shared-api-explorer';
import { isApiExplorerMapFieldValue } from '@squareup/dex-utils-shared-api-explorer';
import { useMemo } from 'react';

const useConvertInputValueToMapFieldValue = (
  value: CodegenInputType
): ApiExplorerMapFieldValue => {
  return useMemo(() => {
    return isApiExplorerMapFieldValue(value) ? value : [];
  }, [value]);
};

export { useConvertInputValueToMapFieldValue };
